/**
 * Serviço do painel gerencial (admin sem instituição).
 */

import { api } from '@/lib/api/client'
import type {
  ManagerialDashboard,
  ManagerialDashboardAudience,
  ManagerialDashboardChartPeriod,
  ManagerialDashboardOrderStatus,
  ManagerialDashboardPeriod,
  ManagerialDashboardSection,
  ManagerialDashboardSectionResponse,
} from '@/types/api'

export interface FetchManagerialDashboardParams {
  period: ManagerialDashboardPeriod
  status: ManagerialDashboardOrderStatus
  institutionId: number | null
  campaignId: number | null
  chartPeriod: ManagerialDashboardChartPeriod
  chartFrom: string | null
  chartTo: string | null
  audience?: ManagerialDashboardAudience
  signal?: AbortSignal
  section?: ManagerialDashboardSection
}

export function buildManagerialDashboardQuery(
  params: Omit<FetchManagerialDashboardParams, 'signal'>
): string {
  const query = new URLSearchParams()
  query.set('period', params.period)
  query.set('status', params.status)
  query.set('chart_period', params.chartPeriod)
  if (params.institutionId !== null) {
    query.set('institution_id', String(params.institutionId))
  }
  if (params.campaignId !== null) {
    query.set('campaign_id', String(params.campaignId))
  }
  if (params.chartPeriod === 'custom') {
    if (params.chartFrom !== null) {
      query.set('chart_from', params.chartFrom)
    }
    if (params.chartTo !== null) {
      query.set('chart_to', params.chartTo)
    }
  }
  return query.toString()
}

export async function fetchManagerialDashboard(
  params: FetchManagerialDashboardParams
): Promise<ManagerialDashboard | ManagerialDashboardSectionResponse> {
  const suffix = buildManagerialDashboardQuery(params)
  const audience = params.audience === 'institution' ? 'institution' : 'admin'
  const path = params.section
    ? `managerial-dashboard/sections/${params.section}`
    : 'managerial-dashboard'
  return api.get<ManagerialDashboard | ManagerialDashboardSectionResponse>(
    `/api/${audience}/${path}?${suffix}`,
    {
      requireAuth: true,
      signal: params.signal,
    }
  )
}
